<template>
  <CollapsableSection
    data-test="chemical-warnings"
    :title="t('warning_labels')"
    section-classes="w-full text-gray-800 border-b border-gray-200 border-solid last:border-0"
    title-classes="lg:text-xl"
    :is-open="isOpen"
    collapsable-padding="px-8 xl:px-12 py-4"
    collapsable-content-classes="px-8 xl:px-12 py-6"
    @update:open="(value) => emit('update:open', value)"
  >
    <div class="grid w-full md:grid-cols-2 gap-y-6">
      <div v-for="(warning, index) in warnings" :key="`warning.signalWord-${index}`" class="flex flex-col gap-y-3">
        <div class="flex flex-row gap-x-3">
          <img v-if="warning.assetUrl" class="w-16 h-16" :src="warning.assetUrl" :alt="warning.signalWord" />
          <img
            v-for="(assetUrl, extraAssetIndex) in warning.extraAssetUrls"
            :key="`warning.signalWord-extraAsset-${extraAssetIndex}`"
            class="w-16 h-16"
            :src="assetUrl"
            :alt="warning.signalWord"
          />
        </div>
        <CHeading :level="4">{{ warning.signalWord }}</CHeading>
        <CText v-if="warning.description" variant="sm">
          <template v-if="warning.code">
            <CText el="b" variant="sm">{{ warning.code }}</CText> -
          </template>
          {{ warning.description }}
        </CText>
        <CText v-else-if="warning.code">
          <CText el="b" variant="sm">{{ warning.code }}</CText>
        </CText>
        <CText v-if="warning.detailedDescription" variant="sm">{{ warning.detailedDescription }}</CText>
      </div>
    </div>
  </CollapsableSection>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
type Props = {
  warnings?: {
    code: string;
    detailedDescription: string;
    description: string;
    signalWord: string;
    assetUrl: string;
    extraAssetUrls?: string[];
  }[];
  isOpen?: boolean;
};

withDefaults(defineProps<Props>(), {
  warnings: () => [],
  isOpen: false,
});

const emit = defineEmits<{
  (e: 'update:open', v: boolean): void;
}>();

const { t } = useI18n();
</script>

<script lang="ts">
export default defineComponent({
  name: 'ProductDetailPageWarningsSection',
});
</script>
